// Persist before sending: reload and an uncertain network result must reuse the same UUID.
// Shared across entry points in this tab, including an unmounted in-flight dialog.
const submitting = new Set();
export function lockAward(key) {
  if (submitting.has(key)) return false;
  submitting.add(key);
  return true;
}
export function unlockAward(key) { submitting.delete(key); }

export function readPendingAward(key) {
  try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
}

export function savePendingAward(key, body) {
  sessionStorage.setItem(key, JSON.stringify(body));
}

export function verifyAwardResponse(body, result) {
  const ids = new Set(body.student_ids);
  if (result?.operation_id !== body.operation_id || result.kind !== body.kind || result.amount !== body.amount
      || result.total_points !== body.amount * ids.size || !Array.isArray(result.students)
      || result.students.length !== ids.size) throw new Error('İşlem sonucu doğrulanamadı. Aynı işlemi tekrar doğrulayın.');
  const returned = new Set();
  for (const row of result.students) {
    if (!ids.has(row.student_id) || returned.has(row.student_id) || row.amount !== body.amount
        || !Number.isInteger(row.available_points)) throw new Error('İşlem sonucu doğrulanamadı. Aynı işlemi tekrar doğrulayın.');
    returned.add(row.student_id);
  }
  return result;
}
